import type { AppDestroyWorkerChannels } from '@bcf-vanilla-ts-v1-logic-worker-others/bloc/app-destroy-worker/app-destroy-worker-channels';
import { provideAppDestroy } from '@bcf-vanilla-ts-v1-shared/di/app-destroy';
import { UnsubscribableWithWorkerBlocForService } from '@bcflit-platforms/platform-worker/browser/unsubscribable-with-worker-bloc-for-service';
import type { ReactiveControllerHost } from 'lit';

/* Destroy AppDestroy ON MAIN THREAD side */
export class AppDestroyController extends UnsubscribableWithWorkerBlocForService<AppDestroyWorkerChannels> {
  constructor(protected override _host: ReactiveControllerHost) {
    super(_host);
    this._initWorkerBloc('app-destroy-worker');
  }

  public override hostDisconnected(): void {
    super.hostDisconnected();
    provideAppDestroy().onAppDestroy();
  }
}

export function provideAppDestroyController(host: ReactiveControllerHost): AppDestroyController {
  return new AppDestroyController(host);
}
